export const STOPWORDS = new Set([
  'the',
  'and',
  'or',
  'but',
  'in',
  'on',
  'at',
  'to',
  'for',
  'of',
  'with',
  'by',
  'a',
  'an',
  'is',
  'are',
  'was',
  'were',
  'be',
  'been',
  'have',
  'has',
  'had',
  'do',
  'does',
  'did',
  'will',
  'would',
  'can',
  'could',
  'should',
  'may',
  'might',
  'it',
  'this',
  'that',
  'these',
  'those',
  'i',
  'you',
  'he',
  'she',
  'we',
  'they',
  'me',
  'him',
  'her',
  'us',
  'them',
  'my',
  'your',
  'his',
  'our',
  'their',
  'from',
  'up',
  'about',
  'into',
  'over',
  'after',
  'get',
  'go',
  'see',
  'come',
  'know',
  'think',
  'take',
  'make',
  'want',
  'say',
  'use',
  'work',
  'try',
  'ask',
]);
